import { api } from "../api";
const BASE_URL = "/system-admin/hiringmanager/applicants";

class ApplicantTrackingAPI {
  async updateApplicationStatus(id, status) {
    return await api.patch(`${BASE_URL}/${id}/status?status=${status}`, {});
  }
}

export const applicantTrackingAPI = new ApplicantTrackingAPI();
